import { Helmet } from "react-helmet-async";

export default function Seo({
  title = "Njia Safaris — Ultra-Luxury African Safaris",
  description = "Njia Safaris — ultra-luxury private African safaris across Kenya, Tanzania and Uganda. Your path to Africa's soul.",
  image = "https://images.unsplash.com/photo-1523805009345-7448845a9e53?auto=format&fit=crop&w=1600&q=80",
  path = "",
  schema,
}) {
  const url = `https://njiasafaris.com${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Njia Safaris" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
